<template>
  <Page>
    <ConfirmModal
      v-if="modal"
      :onClose="handleModal"
      :onConfirm="onDelete">
      <template v-slot:header-title>
        <h4>ยืนยันการลบ</h4>
      </template>
      <div>คุณยืนยันที่จะลบ {{getTitle()}}</div>
    </ConfirmModal>
    <template v-slot:page-header>
      <div class="container">
        <div class="page-header">
          <router-link
            class="btn btn-action btn-action-back"
            :to="`/landingpage`">
            <i class="fas fa-chevron-left" />
          </router-link>
          <div class="title-container">
            <div class="title">แก้ไขแลนดิ้งเพจ</div>
          </div>
          <div class="actions">
            <small class="text-danger mr-3"
              v-if="isServerError()">
              {{getErrorMessageFromErrorStatus(errorStatus)}}
            </small>
            <small class="text-success font-weight-bold mr-3" v-if="saveLandingPageState.isSaved">
              <i class="fa fa-check" /> บันทึกแล้ว
            </small>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!isValid"
              @click.stop="onSubmit">
              บันทึก
            </button>
            <Dropdown :alignment="'right'">
              <template v-slot:dropdow-button>
                <button
                  type="button"
                  class="btn btn-outline-dark btn-action m-0 ml-2">
                  <i class="fas fa-cog"></i>
                </button>
              </template>
              <div class="dropdown-item" @click.stop="handleModal">
                ลบแลนดิ้งเพจ
              </div>
            </Dropdown>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="section-container">
        <SectionLandingPageInformation
          :landingPage.sync="landingPageData"
          :saveLandingPageStateError.sync="saveLandingPageState.error" />
      </div>
    </div>
  </Page>
</template>

<script>
import _ from 'lodash';
import { updateLandingPage, deleteLandingPage } from '@/landingpage/api';
import dateFormetter from '@/utils/dateFormatter';
import errorFormatter from '@/utils/errorFormatter';
import Dropdown from '@/components/Dropdown.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import Page from '@/layouts/Page.vue';
import SectionLandingPageInformation from '@/landingpage/SectionLandingPageInformation.vue';

export default {
  mixins: [dateFormetter, errorFormatter],
  props: {
    landingPage: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Dropdown,
    ConfirmModal,
    SectionLandingPageInformation,
  },
  data() {
    return {
      modal: false,
      landingPageData: null,
      saveLandingPageState: {
        isSaving: false,
        isSaved: false,
        error: {
          title: null,
          redirectUrl: null,
          startPublish: null,
          endPublish: null,
        },
      },
      errorStatus: null,
      emptyFieldError: null,
    };
  },
  created() {
    this.landingPageData = _.cloneDeep(this.landingPage);
  },
  computed: {
    landingPageId() {
      return this.$route.params.id;
    },
    isValid() {
      return !(_.isEmpty(this.landingPageData.title) && _.isEmpty(this.landingPageData.redirectUrl));
    },
  },
  methods: {
    getTitle() {
      return this.landingPageData.title;
    },
    async onSubmit() {
      this.saveLandingPageState.isSaving = true;
      this.saveLandingPageState.isSaved = false;
      try {
        await updateLandingPage(this.landingPageId, this.landingPageData);
        this.saveLandingPageState.isSaving = false;
        this.saveLandingPageState.isSaved = true;
        this.errorStatus = null;
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveLandingPageState.error = this.transformErrorData(error.response.data);
        this.saveLandingPageState.isSaving = false;
      }
    },
    async onDelete() {
      try {
        await deleteLandingPage(this.landingPageId);
        this.$router.push('/landingpage');
      } catch (error) {
        this.errorStatus = error.response.status;
        this.saveLandingPageState.error = error.response.data;
      }
    },
    handleModal() {
      this.modal = !this.modal;
    },
    isServerError() {
      return this.errorStatus;
    },
    getErrorMessageFromErrorStatus(errorStatus) {
      if (errorStatus === 500) {
        return `พบข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองอีกครั้งหรือติดต่อผู้ดูแลระบบ code : ${errorStatus}`;
      }
      if (errorStatus === 422) {
        return 'กรอกข้อมูลไม่ถุกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/layouts/page.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
